import {
    FGCheckbox,
    FGStack,
    FGStackItem,
    FGTile,
    FGTypography,
} from '@fg/design-system';

type Props = {
    onClick: () => void;
    isAllSelected: boolean;
    isSomeSelected: boolean;
    numCountriesSelected: number;
};

const NewCountryPickerSelectAllListItem = (props: Props) => {
    const {
        onClick,
        isAllSelected,
        isSomeSelected,
        numCountriesSelected,
    } = props;
    return (
        <FGTile
            appearance="secondary"
            padding="small"
            style={{ width: '100%' }}
            onClick={onClick}>
            <FGStack
                style={{ width: '100%', pointerEvents: 'none' }}
                alignItems="center"
                justifyContent="space-between">
                <FGStackItem>
                    <FGStack
                        alignItems="center"
                        gap={10}
                        justifyContent="space-between">
                        <FGCheckbox
                            isChecked={isAllSelected}
                            isIndeterminate={isSomeSelected}
                        />
                        <FGTypography tag="label" variant="label2">
                            Select all
                        </FGTypography>
                    </FGStack>
                </FGStackItem>
                {numCountriesSelected > 0 && (
                    <FGStackItem>
                        <FGTypography
                            tag="label"
                            variant="body3-short"
                            cssStyle={{ color: 'var(--fg-color-text-light)' }}>
                            {`(${numCountriesSelected})`}
                        </FGTypography>
                    </FGStackItem>
                )}
            </FGStack>
        </FGTile>
    );
};

export default NewCountryPickerSelectAllListItem;
